// Adapted from davinci-elections apps/web/src/providers.tsx @ 6e23f58
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { PropsWithChildren } from 'react'
import { isApiError } from '~/api/client'
import { Theme } from '~/theme/Theme'
import '~/i18n'

/** No retries on 4xx, short stale time. */
export const createAppQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && error.status >= 400 && error.status < 500) return false
          return failureCount < 2
        },
      },
      mutations: { retry: false },
    },
  })

const queryClient = createAppQueryClient()

export const Providers = ({ children, client = queryClient }: PropsWithChildren<{ client?: QueryClient }>) => (
  <QueryClientProvider client={client}>
    <Theme>{children}</Theme>
  </QueryClientProvider>
)
